import { ChangeEvent } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import styled from 'styled-components';

// Styled checkbox to grab user attention
const StyledCheckbox = styled(Input)`
  /* Red (danger) styling when unchecked */
  &:not(:checked) {
    border-color: #dc3545;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
  }

  /* Blue (primary) styling when checked */
  &:checked {
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }
`;

export interface LegalAgreementCheckboxProps {
  readonly legalAccepted: boolean;
  readonly setLegalAccepted: (accepted: boolean) => void;
  readonly className?: string;
}

export function LegalAgreementCheckbox({
  legalAccepted,
  setLegalAccepted,
  className,
}: LegalAgreementCheckboxProps) {
  return (
    <FormGroup check className={className}>
      <StyledCheckbox
        type="checkbox"
        name="legalAccepted"
        id="legalAccepted"
        required
        checked={legalAccepted}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setLegalAccepted(e.target.checked)
        }
      />
      <Label for="legalAccepted" check>
        <p className="mb-3">
          <strong>
            By checking the box, you acknowledge and agree to our{' '}
            <a
              href="https://www.fishwindowcleaning.com/terms-of-use"
              target="_blank"
              rel="noopener"
            >
              Terms of Use
            </a>{' '}
            and{' '}
            <a
              href="https://www.fishwindowcleaning.com/privacy-policy"
              target="_blank"
              rel="noopener"
            >
              Privacy Policy
            </a>
            .{' '}
            <span className="text-danger" aria-hidden="true">
              *
            </span>
            <span className="visually-hidden">(required)</span>
          </strong>
        </p>
        <p className="mb-0">
          Please note that all payments are processed through a third-party
          payment provider and gateway provider, including but not limited to
          Evalon, Inc.
        </p>
      </Label>
    </FormGroup>
  );
}
